// extracted by mini-css-extract-plugin
module.exports = {"stateIcon":"StateCell_stateIcon__14_XG"};